// Local translations
export const T = {
  en_GB: {
    text: "Text",
    number: "Number",
    dropdown: "Dropdown",
    textArea: "Text Area",
    date: "Date",
    datetime: "Date and time",
    email: "Email",
    phone: "Phone",
    error: "Error",
    failedToDeleteField: "Failed to delete field",
    ok: "OK",
    fieldsTitle: "Custom Fields",
    fieldsDescription: "Define custom data fields that clients can fill in during the flow.",
    addField: "Add Field",
    editField: "Edit field",
    duplicateField: "Duplicate field",
    noFieldsYet: "No fields defined yet. Create your first field to get started.",
    name: "Name",
    type: "Type",
    scope: "Scope",
    syncKey: "Sync key",
    required: "Required",
    actions: "Actions",
    goal: "Goal",
    global: "Global",
    portfolio: "Portfolio",
    optional: "Optional",
    deleteField: "Delete Field",
    deleteFieldConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    cancel: "Cancel",
    deleting: "Deleting...",
    delete: "Delete",
  },
  nb_NO: {
    text: "Tekst",
    number: "Tall",
    dropdown: "Nedtrekksmeny",
    textArea: "Tekstfelt",
    date: "Dato",
    datetime: "Dato og klokkeslett",
    email: "E-post",
    phone: "Telefon",
    error: "Feil",
    failedToDeleteField: "Kunne ikke slette felt",
    ok: "OK",
    fieldsTitle: "Egendefinerte felt",
    fieldsDescription: "Definer egendefinerte datafelt som kunder kan fylle ut under flyten.",
    addField: "Legg til felt",
    editField: "Rediger felt",
    duplicateField: "Dupliser felt",
    noFieldsYet: "Ingen felt definert ennå. Opprett ditt første felt for å komme i gang.",
    name: "Navn",
    type: "Type",
    scope: "Omfang",
    syncKey: "Synkroniseringsnøkkel",
    required: "Obligatorisk",
    actions: "Handlinger",
    goal: "Mål",
    global: "Global",
    portfolio: "Portefølje",
    optional: "Valgfritt",
    deleteField: "Slett felt",
    deleteFieldConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    cancel: "Avbryt",
    deleting: "Sletter...",
    delete: "Slett",
  },
} as const;
